import { render } from "./Contact.vue?vue&type=template&id=0a2c0932&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=0a2c0932&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0a2c0932"

export default script